import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { addTool } from '../toolService';

const AddToolForm = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    url: '',
    method: 'GET',
    body_mode: 'none',
    formdata: '',
    raw_body: '',
    headers: '',
    full_description: '',
    request_description: '',
    response_description: '',
    example_response: ''
  });
  const [bodyType, setBodyType] = useState('none');
  const [formFields, setFormFields] = useState([{ key: '', value: '', description: '', type: 'text' }]);
  const [headerFields, setHeaderFields] = useState([{ key: '', value: '', disabled: false }]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBodyTypeChange = (e) => {
    setBodyType(e.target.value);
    setFormData({ ...formData, body_mode: e.target.value });
  };

  const handleFormFieldChange = (index, field, value) => {
    const updatedFields = [...formFields];
    updatedFields[index][field] = value;
    setFormFields(updatedFields);
    
    // Update formdata in the main form
    setFormData({
      ...formData,
      formdata: JSON.stringify({ formdata: updatedFields })
    });
  };

  const handleHeaderFieldChange = (index, field, value) => {
    const updatedFields = [...headerFields];
    updatedFields[index][field] = value;
    setHeaderFields(updatedFields);
    
    // Update headers in the main form
    setFormData({
      ...formData,
      headers: JSON.stringify(updatedFields)
    });
  };

  const addFormField = () => {
    setFormFields([...formFields, { key: '', value: '', description: '', type: 'text' }]);
  };

  const removeFormField = (index) => {
    const updatedFields = formFields.filter((_, i) => i !== index);
    setFormFields(updatedFields);
    setFormData({
      ...formData,
      formdata: JSON.stringify({ formdata: updatedFields })
    });
  };

  const addHeaderField = () => {
    setHeaderFields([...headerFields, { key: '', value: '', disabled: false }]);
  };

  const removeHeaderField = (index) => {
    const updatedFields = headerFields.filter((_, i) => i !== index);
    setHeaderFields(updatedFields);
    setFormData({
      ...formData,
      headers: JSON.stringify(updatedFields)
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      await addTool(formData);
      navigate('/marketplace');
    } catch (error) {
      console.error('Error adding tool:', error);
      alert('Failed to add tool. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-4xl mx-auto p-6 bg-white rounded-lg shadow-md">
      <h1 className="text-2xl font-bold mb-6">Add New Tool</h1>
      
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Basic Information */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold border-b pb-2">Basic Information</h2>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Tool Name</label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Description</label>
            <input
              type="text"
              name="description"
              value={formData.description}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>
        </div>
        
        {/* Request Details */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold border-b pb-2">Request Details</h2>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">URL</label>
            <input
              type="text"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              required
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Method</label>
            <select
              name="method"
              value={formData.method}
              onChange={handleInputChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            >
              <option value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
              <option value="PATCH">PATCH</option>
            </select>
          </div>
          
          {/* Headers */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Headers</label>
            {headerFields.map((header, index) => (
              <div key={index} className="flex items-center space-x-2 mb-2">
                <input
                  type="text"
                  placeholder="Key"
                  value={header.key}
                  onChange={(e) => handleHeaderFieldChange(index, 'key', e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                />
                <input
                  type="text"
                  placeholder="Value"
                  value={header.value}
                  onChange={(e) => handleHeaderFieldChange(index, 'value', e.target.value)}
                  className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                />
                <button
                  type="button"
                  onClick={() => removeHeaderField(index)}
                  className="px-3 py-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200"
                >
                  Remove
                </button>
              </div>
            ))}
            <button
              type="button"
              onClick={addHeaderField}
              className="mt-2 px-3 py-1 bg-gray-100 text-gray-600 rounded-md hover:bg-gray-200"
            >
              Add Header
            </button>
          </div>
          
          {/* Body Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700">Body Type</label>
            <select
              value={bodyType}
              onChange={handleBodyTypeChange}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
            >
              <option value="none">None</option>
              <option value="formdata">Form Data</option>
              <option value="raw">Raw</option>
            </select>
          </div>
          
          {/* Form Data Fields */}
          {bodyType === 'formdata' && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">Form Data Fields</label>
              {formFields.map((field, index) => (
                <div key={index} className="grid grid-cols-4 gap-2 mb-2">
                  <input
                    type="text"
                    placeholder="Key"
                    value={field.key}
                    onChange={(e) => handleFormFieldChange(index, 'key', e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                  />
                  <input
                    type="text"
                    placeholder="Value"
                    value={field.value}
                    onChange={(e) => handleFormFieldChange(index, 'value', e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                  />
                  <input
                    type="text"
                    placeholder="Description"
                    value={field.description}
                    onChange={(e) => handleFormFieldChange(index, 'description', e.target.value)}
                    className="px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                  />
                  <div className="flex items-center space-x-2">
                                        <select
                      value={field.type}
                      onChange={(e) => handleFormFieldChange(index, 'type', e.target.value)}
                      className="flex-1 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
                    >
                      <option value="text">Text</option>
                      <option value="file">File</option>
                    </select>
                    <button
                      type="button"
                      onClick={() => removeFormField(index)}
                      className="px-3 py-2 bg-red-100 text-red-600 rounded-md hover:bg-red-200"
                    >
                      Remove
                    </button>
                  </div>
                </div>
              ))}
              <button
                type="button"
                onClick={addFormField}
                className="mt-2 px-3 py-1 bg-gray-100 text-gray-600 rounded-md hover:bg-gray-200"
              >
                Add Field
              </button>
            </div>
          )}
          
          {/* Raw Body */}
          {bodyType === 'raw' && (
            <div>
              <label className="block text-sm font-medium text-gray-700">Raw Body</label>
              <textarea
                name="raw_body"
                value={formData.raw_body}
                onChange={handleInputChange}
                rows={6}
                className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary font-mono"
              />
            </div>
          )}
        </div>
        
        {/* Documentation */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold border-b pb-2">Documentation</h2>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Full Description (Markdown)</label>
            <textarea
              name="full_description"
              value={formData.full_description}
              onChange={handleInputChange}
              rows={10}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary font-mono"
              placeholder="# API Documentation

## Overview

Describe your API here using Markdown formatting..."
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Request Description</label>
            <textarea
              name="request_description"
              value={formData.request_description}
              onChange={handleInputChange}
              rows={3}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              placeholder="Describe how to use the request parameters..."
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Response Description</label>
            <textarea
              name="response_description"
              value={formData.response_description}
              onChange={handleInputChange}
              rows={3}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary"
              placeholder="Describe what the API returns..."
            />
          </div>
          
          <div>
            <label className="block text-sm font-medium text-gray-700">Example Response</label>
            <textarea
              name="example_response"
              value={formData.example_response}
              onChange={handleInputChange}
              rows={6}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary font-mono"
              placeholder='{"example": "response", "data": "values"}'
            />
          </div>
        </div>
        
        {/* Submit Button */}
        <div className="flex justify-end space-x-3">
          <button
            type="button"
            onClick={() => navigate('/marketplace')}
            className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={loading}
            className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary-dark focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary"
          >
            {loading ? (
              <>
                <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white inline" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Saving...
              </>
            ) : (
              'Add Tool'
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddToolForm;